import { useState, useEffect } from 'react';
import signalRService from '../lib/api/signalRService';

/**
 * Hook to manage safety concern notifications from the Pokket AI
 * 
 * @param {boolean} connectionEstablished - Whether the SignalR connection is established
 * @returns {Object} Safety concern state and controls
 */
const useSafetyConcern = (connectionEstablished) => {
  // Initialize state from localStorage if available
  const [showSafetyConcern, setShowSafetyConcern] = useState(() => {
    const savedConcern = localStorage.getItem('pokket_safety_concern');
    return savedConcern === 'true';
  });
  
  const DEBUG = true; // Match the DEBUG flag from ChatPage
  
  // Listen for SafetyConcern from SignalR
  useEffect(() => {
    if (!connectionEstablished) return;
    
    // Register handler using the correct structure for the SafetyConcern event
    signalRService.connection.on('SafetyConcern', (response) => {
      // Simple console log as requested
      console.log('Safety concern flagged:', response.flagged);
      
      // Styled logging for better visibility
      console.log(`%c⚠️ SafetyConcern: ${response?.flagged}`, 'color: orange; font-weight: bold');
      
      // Log full response object if in debug mode
      if (DEBUG) console.log("Received safety concern:", response);
      
      // Only show the notification if flagged is true
      if (response && response.flagged === true) {
        setShowSafetyConcern(true);
        
        // Store in localStorage to persist between refreshes
        localStorage.setItem('pokket_safety_concern', 'true');
      }
    });
    
    // Clean up function to remove the event handler
    return () => {
      if (signalRService.connection) {
        signalRService.connection.off('SafetyConcern');
      }
    };
  }, [connectionEstablished, DEBUG]);

  // Function to dismiss the notification
  const dismissSafetyConcern = () => {
    setShowSafetyConcern(false);
    localStorage.removeItem('pokket_safety_concern');
  };
  
  return {
    showSafetyConcern,
    dismissSafetyConcern
  };
};

export default useSafetyConcern; 